import settings from './settings';

const { anvp } = window;

const getAktaPlayerMount = () => {
  let mountEl = null;

  // The lockscreen portal will be mounted to the first player on the page
  // that includes the Adobe plugin. Including the lock screen on multiple
  // players at once will require more centralization of state so that the lock
  // is dismissed simultaneously.
  Array.from(document.querySelectorAll('.ns-block-embed-anvato')).some(
    (el) => {
      const playerId = el.dataset?.anvatoPlayerId ?? null;

      if (! playerId) {
        return false;
      }

      const playerInstance = anvp?.[playerId] ?? null;
      const config = playerInstance?.mergedConfig
        ?? playerInstance?.config
        ?? null;
      const enabled = config?.plugins?.adobePrimetimePlugin ?? null;

      if (! enabled) {
        return false;
      }

      mountEl = el.querySelector('.ns-block-embed__wrapper');
      return true;
    },
  );

  return mountEl;
};

const getOvpPlayerMount = () => {
  let mountEl = null;

  Array.from(document.querySelectorAll('.nxs-player-wrapper')).some(
    (el) => {
      try {
        const playerId = el.dataset?.player_id ?? null; // eslint-disable-line camelcase

        if (! playerId) {
          return false;
        }

        const videoParams = el.dataset?.video_params ?? null; // eslint-disable-line camelcase
        // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.replaceAll
        const config = JSON.parse(videoParams.replaceAll('\'/', '"')) || {};
        const enabled = config?.plugins?.adobePrimetimePlugin ?? null;

        if (! enabled) {
          return false;
        }

        mountEl = el.querySelector(`#${playerId}`);
        return true;
      } catch (e) {
        return false;
      }
    },
  );
  return mountEl;
};

const getPlayerMount = () => {
  if (settings('use_ovp')) {
    return getOvpPlayerMount();
  }

  return getAktaPlayerMount();
};

export default getPlayerMount;

